import { useState, useEffect, useCallback } from 'react';

import { currentBreakpoint } from '../attrs/mq';

import { useWindowSize } from './useWindowSize';

export function useBreakpoints() {
  const { width } = useWindowSize();

  const getSize = useCallback(() => {
    return currentBreakpoint(width);
  }, [width]);

  const [breakpoint, setBreakpoint] = useState(getSize);

  useEffect(() => {
    setBreakpoint(getSize());
  }, [getSize]);

  return breakpoint;
}
